import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { updateSearch } from "../../../actions/ChoThongTin/DanhSachVay";
import  danhSachThongTinVayApi  from "../../../service/ChoThongTin/danhSachThongTinVayApi";


export const SearchBar = () => {
  const dispatch = useDispatch();
 
  const dataSearch = useSelector((state) => state.danhSachThongTinVay);
  const [dataTinh, setDataTinh] = useState([]);
  const [dataHuyen, setDataHuyen] = useState([]);

  const updateState = (field, text) => {
    dispatch(
      updateSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };
  useEffect(() => {
    danhSachThongTinVayApi.getTinhThanhByLevel(1).then((response) => {
      setDataTinh(response.data.List);
    });
    onSearch();
  }, []);

  
  const loadTaiSan = () => {
  
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang
  const updateDropdown = (field) => (e) => {
    updateState(field, e.target.value);
    if(field == "IdTinh"){
      danhSachThongTinVayApi.getTinhThanhByIdParent(e.target.value).then((response) => {
        setDataHuyen(response.data.List);
    });
    }
  };


  const onSearch = () => {
    danhSachThongTinVayApi.danhSachDangKyVay(dataSearch).then((response) => {
      dispatch(
        updateSearch({
          ...dataSearch,
          lstDanhSach: response.data.List,
          iTotal: response.data.iTotal,
        })
      );
    });
  };


  return (
    <>
      <div className="search-main">
        <div className="row">
            <div class="form-group mb-1 col-sm-12 col-md-3">
             
              <select class="form-control selectCss"
                        value={dataSearch.IdTinh}
                        onChange={updateDropdown("IdTinh")}
                      >
                        <option value="0">-- Chọn tỉnh --</option>
                        {dataTinh.map(
                                          (option, i) => {
                                            const { Name, Id } = option;
                                            return (
                                              <option value={Id}>
                                                {Name}
                                              </option>
                                            );
                                          }
                                        )}
                      </select>
            </div>
            <div class="form-group mb-1 col-sm-12 col-md-3">
              
              <select class="form-control selectCss"
                        value={dataSearch.IdHuyen}
                        onChange={updateDropdown("IdHuyen")}
                      >
                        <option value="0">-- Chọn huyện --</option>
                        {dataHuyen.map(
                                          (option, i) => {
                                            const { Name, Id } = option;
                                            return (
                                              <option value={Id}>{Name}</option>
                                            );
                                          }
                                        )}
              </select>
            </div>
            <div class="form-group mb-1 col-sm-12 col-md-3">
            <div className="input-sm-new input-new-18 search-main-new">
          <button type="submit" className="btn btn-info-new" onClick={onSearch}>
            <i className="la la-search"></i>
          </button>
        </div>
              
            </div>

           


          <div className="col-md-4">
            <div className="align-end marT-20">
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
